import esTranslation from './es';

const resources = {
	es: esTranslation,
} as const;

const ns = ['common', 'system', 'users', 'vehicles', 'access', 'nfc'];

export { resources as default, ns };
